/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { PalSubmissionListEntryTimExecutionPayor } from './PalSubmissionListEntryTimExecutionPayor';
import {
    PalSubmissionListEntryTimExecutionPayorFromJSON,
    PalSubmissionListEntryTimExecutionPayorFromJSONTyped,
    PalSubmissionListEntryTimExecutionPayorToJSON,
} from './PalSubmissionListEntryTimExecutionPayor';

/**
 * Subset of PalAuthPlatformPayorForm for list view
 * @export
 * @interface PalSubmissionListEntryAuthPlatformForm
 */
export interface PalSubmissionListEntryAuthPlatformForm {
    /**
     * 
     * @type {PalSubmissionListEntryTimExecutionPayor}
     * @memberof PalSubmissionListEntryAuthPlatformForm
     */
    auth_platform?: PalSubmissionListEntryTimExecutionPayor;
}

/**
 * Check if a given object implements the PalSubmissionListEntryAuthPlatformForm interface.
 */
export function instanceOfPalSubmissionListEntryAuthPlatformForm(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function PalSubmissionListEntryAuthPlatformFormFromJSON(json: any): PalSubmissionListEntryAuthPlatformForm {
    return PalSubmissionListEntryAuthPlatformFormFromJSONTyped(json, false);
}

export function PalSubmissionListEntryAuthPlatformFormFromJSONTyped(json: any, ignoreDiscriminator: boolean): PalSubmissionListEntryAuthPlatformForm {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'auth_platform': !exists(json, 'auth_platform') ? undefined : PalSubmissionListEntryTimExecutionPayorFromJSON(json['auth_platform']),
    };
}

export function PalSubmissionListEntryAuthPlatformFormToJSON(value?: PalSubmissionListEntryAuthPlatformForm | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'auth_platform': PalSubmissionListEntryTimExecutionPayorToJSON(value.auth_platform),
    };
}

